import { mergeOnBond, mergeOnPivot, createOnEmpty, addAtom, addBond } from '@moleculeone/draw';

import { DEFAULT_MODE, FRAGMENT_BOND_MODE, MOL_MOUSE_EVENT, MOUSE_DOWN } from '../../../../etc/constants';
import { updateMols, updateState } from '../../../state';

import { rankedCandidates } from './positionCandidates';

function effect(state, action) {
  if (action.type !== MOL_MOUSE_EVENT) {
    return {};
  }

  return baseEffect(state.mols, state.mode, action.event, state.mouse.molIndex);
}

function baseEffect(mols, mode, event, molIndex) {
  if (event.type !== MOUSE_DOWN) {
    return {};
  }

  const { data } = mode;
  let newMol = mols[molIndex];

  if (event.bond) {
    newMol = mergeOnBond(newMol, event.idx, data.fragment, data.idx, event.ctrlKey);
  } else if (event.atom) {
    let target = event.idx;
    if (event.shiftKey) {
      const newPosition = rankedCandidates(newMol, event.idx)[0];
      const [anotherMol, newAtom] = addAtom(newMol, newPosition);
      newMol = anotherMol;
      [newMol] = addBond(newMol, event.idx, newAtom.idx);
      target = newAtom.idx;
    }
    const fragBond = data.fragment.bonds[data.idx];
    const fragIdx = event.ctrlKey ? fragBond.start : fragBond.end;
    newMol = mergeOnPivot(newMol, target, data.fragment, fragIdx);
  } else if (event.empty) {
    const bond = data.fragment.bonds[data.idx];
    newMol = createOnEmpty(newMol, data.fragment, [bond.start, bond.end], event.svgPos);
  }

  return { mols: updateMols(mols, newMol, molIndex) };
}

function preview(state) {
  const { lastMove, molIndex } = state.mouse;
  if (lastMove != null) {
    const maybeEvent = updateState(lastMove, { type: MOUSE_DOWN });
    const previewState = baseEffect(state.mols, state.mode, maybeEvent, molIndex);
    const previewMol = previewState.mols[molIndex];

    if (previewMol != null && previewMol !== state.mols[molIndex]) {
      const editedBonds = {};
      for (const [key, bond] of Object.entries(previewMol.bonds)) {
        if (state.mols[molIndex].bonds[key] !== bond) {
          editedBonds[key] = { ...bond, preview: true };
        }
      }
      return updateState(previewMol, { bonds: updateState(previewMol.bonds, editedBonds) });
    }
  }
  return null;
}

function cleanup(mode) {
  return mode;
}

const initial = {
  type: DEFAULT_MODE,
  data: null,
};

export function bondFragmentData(fragment, idx) {
  return {
    type: FRAGMENT_BOND_MODE,
    data: {
      fragment,
      idx,
    },
  };
}

export const trait = {
  type: DEFAULT_MODE,
  initial,
  effect,
  preview,
  cleanup,
};
